import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36a0069e"
import script from "./index.ts?vue&type=script&lang=js&external"
export * from "./index.ts?vue&type=script&lang=js&external"
import style0 from "./index.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports